<script setup lang="ts">
import Header from '@/components/Header/Header.vue'
import Footer from '@/components/shared/Footer.vue'
import { cn } from '@/lib/utils'
import { HTMLAttributes } from 'vue'

const props = defineProps<{ contentClasses?: string; class?: HTMLAttributes['class']; hideFooter?: boolean }>()
</script>
<template>
    <div :class="cn('font-inter overflow-hidde relative min-h-dvh bg-slate-50', props.class)">
        <Header :dark="true" :logo-type="true" />
        <div class="absolute min-h-[300px] w-full bg-gray-900"></div>
        <div :class="cn('relative z-30 container min-h-[70vh] py-44 text-slate-800', contentClasses)">
            <slot />
        </div>
        <Footer :dark="false" v-if="!hideFooter" />
    </div>
</template>
